import { DuplicateVideoMenu, ItemId, VideoMenu} from '../../../types/items';
import { ItemList, ListParams } from '../../../types/main';
import { action, withoutPayload, withPayload } from '../../../utility/redux';

export const initVideoMenuRequest = action(
  'INIT_VIDEO_MENU_REQUEST',
  withoutPayload,
);
export const initVideoMenuSuccess = action(
  'INIT_VIDEO_MENU_SUCCESS',
  withPayload<VideoMenu>(),
);
export const initVideoMenuFail = action(
  'INIT_VIDEO_MENU_FAIL',
  withoutPayload,
);

export const createVideoMenuRequest = action(
  'CREATE_VIDEO_MENU_REQUEST',
  withPayload<VideoMenu>(),
);
export const createVideoMenuSuccess = action(
  'CREATE_VIDEO_MENU_SUCCESS',
  withPayload<VideoMenu>(),
);
export const createVideoMenuFail = action(
  'CREATE_VIDEO_MENU_FAIL',
  withoutPayload,
);

export const getVideoMenuListRequest = action(
  'GET_VIDEO_MENU_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getVideoMenuListSuccess = action(
  'GET_VIDEO_MENU_LIST_SUCCESS',
  withPayload<ItemList<VideoMenu>>(),
);
export const getVideoMenuListFail = action(
  'GET_VIDEO_MENU_LIST_FAIL',
  withoutPayload,
);

export const setVideoMenuListDirty = action(
  'SET_VIDEO_MENU_LIST_DIRTY',
  withPayload<boolean>(),
);

export const getVideoMenuRequest = action(
  'GET_VIDEO_MENU_REQUEST',
  withPayload<ItemId>(),
);
export const getVideoMenuSuccess = action(
  'GET_VIDEO_MENU_SUCCESS',
  withPayload<VideoMenu>(),
);
export const getVideoMenuFail = action(
  'GET_VIDEO_MENU_FAIL',
  withoutPayload,
);

export const resetCurrentVideoMenu = action(
  'RESET_CURRENT_VIDEO_MENU',
  withoutPayload,
);

export const saveVideoMenuRequest = action(
  'SAVE_VIDEO_MENU_REQUEST',
  withPayload<VideoMenu>(),
);
export const saveVideoMenuSuccess = action(
  'SAVE_VIDEO_MENU_SUCCESS',
  withPayload<VideoMenu>(),
);
export const saveVideoMenuFail = action(
  'SAVE_VIDEO_MENU_FAIL',
  withoutPayload,
);

export const deleteVideoMenuRequest = action(
  'DELETE_VIDEO_MENU_REQUEST',
  withPayload<ItemId>(),
);
export const deleteVideoMenuSuccess = action(
  'DELETE_VIDEO_MENU_SUCCESS',
  withoutPayload,
);
export const deleteVideoMenuFail = action(
  'DELETE_VIDEO_MENU_FAIL',
  withoutPayload,
);

export const duplicateVideoMenuRequest = action(
  'DUPLICATE_VIDEO_MENU_REQUEST',
  withPayload<DuplicateVideoMenu>(),
);
export const duplicateVideoMenuSuccess = action(
  'DUPLICATE_VIDEO_MENU_SUCCESS',
  withPayload<VideoMenu>(),
);
export const duplicateVideoMenuFail = action(
  'DUPLICATE_VIDEO_MENU_FAIL',
  withoutPayload,
);

export const clearVideoMenuList = action(
  'CLEAR_VIDEO_MENU_LIST',
  withoutPayload,
);
